import Component from '../component/component';

import './dropdown.scss';

export default class Dropdown extends Component {
    static initSelector: string = '.dropdown';

    public button: JQuery;
    public title: JQuery;
    public activeItem: JQuery;
    public isGrid: boolean;
    private selectedItem: JQuery | null = null;

    constructor(target: HTMLElement) {
        super(target);

        this.button = this.element.find('.js-dropdown-trigger');
        this.title = this.element.find('.dropdown__title');
        this.isGrid = this.element.parents('.hero-navigation--grid').length > 0 || this.element.hasClass('dropdown--links');

        this.init();
    }

    init(): void {
        $(document).off('click.checkOutsideClick');
        $(document).on('click.checkOutsideClick', this.checkOutsideClick.bind(this));

        this.element.off('click', '.dropdown__link', this.itemClickHandler.bind(this));
        this.element.on('click', '.dropdown__link', this.itemClickHandler.bind(this));

        const firstItemTitle: string = this.element.find('.dropdown__item:first .dropdown__link').text();

        this.title.html(firstItemTitle);

        this.button.off('click.toggleHandler');
        this.button.on('click.toggleHandler', this.toggleHandler.bind(this));

        if (this.isGrid) {
            this.activeItem = this.element.find('.dropdown__link.is-current');

            if (this.activeItem.length > 0) {
                this.setActiveItem();
            }
        }
    }

    setActiveItem():void {
        this.title.text(this.activeItem.text());
    }

    toggleHandler(): void {
        this.element.toggleClass('is-open');
    }

    checkOutsideClick(event: JQuery.TriggeredEvent): void {
        const target: JQuery = $(event.target);

        if (!target.parents('.dropdown').length) {
            this.element.removeClass('is-open');
        }
    }

    itemClickHandler(event: JQuery.ClickEvent): void {
        if (!this.isGrid) {
            event.preventDefault();
        }

        const selectedItem: JQuery = $(event.currentTarget);
        const selectedTitle: string = selectedItem.text();

        this.title.text(selectedTitle);
        this.selectedItem = selectedItem;

        this.element.removeClass('is-open');
    }
}
